import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import { HR_LETTERS_SUMMARY } from '../letterEndpoints'
import { LETTERS_SUMMARY_QUERY_KEY } from '../letterQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { LetterSummaryDto } from '@/modules/Secretariat/types/api/letter'

export function fetchLetterSummary(): Promise<LetterSummaryDto> {
  return axiosInstance
    .get<LetterSummaryDto>(HR_LETTERS_SUMMARY)
    .then((response) => response.data)
}

export function useLetterSummaryQuery(
  options?: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof fetchLetterSummary>>>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: [LETTERS_SUMMARY_QUERY_KEY],
    queryFn: fetchLetterSummary,
    ...options,
  })
}
